// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3307":"ddb5f065","7562":"3c19c353"}[chunkId] + ".chunk.css";
};